module.exports = __webpack_public_path__ + "media/product/f-4-064ad840.png";